import { render, staticRenderFns } from "./PublicOrdersPublicGrid.vue?vue&type=template&id=965478f2&scoped=true"
import script from "./PublicOrdersPublicGrid.vue?vue&type=script&lang=js"
export * from "./PublicOrdersPublicGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965478f2",
  null
  
)

export default component.exports